(function (app, ng) {
    var addingStickyNote = false;

    app.directive("stickyNoteAdd", ["stickyNoteDndService", "$document", "$timeout", function (stickyNoteDndService, $document, $timeout) {
        return {
            link: function (scope, elem) {
                elem[0].draggable = "true";
                elem[0].style.background = "transparent";

                var darkenClass = " sticky-note-darken";
                var dropperClass = " sticky-note-dropper";

                var clone = elem.clone();
                clone[0].className += dropperClass;
                clone[0].style.background = "none";

                elem.on("dragstart", function (e) {
                    var ev = e.originalEvent;

                    //console.log("dragstart from directive");
                    //see http://mdn.github.io/drag-and-drop/copy-move-DataTransfer.html
                    ev.effectAllowed = "copyMove";
                    ev.dropEffect = "copy";

                    ev.dataTransfer.setData("source", "sticky-note-add");

                    if (ev.dataTransfer.setDragImage) //IE does not support
                        ev.dataTransfer.setDragImage(clone[0], clone[0].clientWidth, clone[0].clientHeight);

                    $timeout(function () {
                        e.preventDefault();

                        stickyNoteDndService.beginDrag();
                    });
                });

                var func = function (e) {
                    e.preventDefault();
                    stickyNoteDndService.endDrag();
                    $document[0].body.className = $document[0].body.className.replace(darkenClass, "");
                    elem[0].className = elem[0].className.replace(dropperClass, "");

                    //e.originalEvent.dataTransfer.clearData(); //firefox throws NoModificationAllowedError: Modifications are not allowed for this document
                };

                $document.on("dragend", func);
                scope.$on("$destroy", function () {
                    $document.off("dragend", func);
                });

                elem.on("click", function (e) {
                    if (!addingStickyNote) {
                        $timeout(function () {
                            e.preventDefault();
                            stickyNoteDndService.beginDrag();
                            addingStickyNote = true;
                        });
                    }
                });

                var clickFunc = function(e) {
                    if (addingStickyNote) {
                        $document[0].body.className = $document[0].body.className.replace(darkenClass, "");
                        elem[0].className = elem[0].className.replace(dropperClass, "");

                        //$timeout(function () {
                        e.preventDefault();
                        stickyNoteDndService.endDrag();
                        //});
                        addingStickyNote = false;
                    }
                };

                $document.on("click", clickFunc);
                scope.$on("$destroy", function () {
                    $document.off("click", clickFunc);
                });
            }
        };
    }]);

    app.directive("stickyNoteZone", [function () {
        return {
            scope: { zone: "@stickyNoteZone", stickyNotes: "<", clientId: "<" },
            controllerAs: "stickyNoteCtrl",
            bindToController: true,
            controller: [function () {
                var $ctrl = this;

                this.$onInit = function () {
                    this.stickyNotes = this.stickyNotes.filter(function (note) { return note.Location === $ctrl.zone; });
                    var listeners = [];

                    ng.extend($ctrl,
                    {
                        registerCallback: registerCallback,
                        onNewStickyNote: onNewStickyNote
                    });

                    function registerCallback(callbackFn) {
                        listeners.push(callbackFn);
                    }

                    function onNewStickyNote() {
                        listeners.forEach(function (listener) { listener(); });
                    }
                };
            }]
        };
    }]);

    app.directive("stickyNoteCounter", [function () {
        return {
            scope: {},
            require: ["^stickyNoteZone", "stickyNoteCounter"],
            template: "<div class='sticky-note-counter' ng-if='counter.count>0'>{{counter.count}}</div>",
            controllerAs: "counter",
            controller: [function () { }],
            link: function (scope, elem, attr, ctrls) {
                var stickyNoteZoneCtrl = ctrls[0];
                var myCtrl = ctrls[1];
                myCtrl.count = stickyNoteZoneCtrl.stickyNotes.length;

                stickyNoteZoneCtrl.registerCallback(function () {
                    myCtrl.count++;
                });
            }
        };
    }]);

    app.directive("stickyNoteDrop", ["stickyNoteDndService", "$mdDialog", function (stickyNoteDndService, $mdDialog) {
        var draggingClass = "sticky-note-dragging";
        var blockerClass = "sticky-note-hover-block";
        return {
            require: ["^stickyNoteZone"],
            link: function (scope, elem, attr, ctrls) {
                var stickyNoteZoneCtrl = ctrls[0];
                var zone = stickyNoteZoneCtrl.zone;
                var unsubscribeBeginDrag = stickyNoteDndService.onBeginDrag(function () {
                    elem.addClass(draggingClass);
                    // Class used to block existent hover activity:
                    // :not(.sticky-note-hover-block)
                    elem.addClass(blockerClass);
                });
                var unsubscribeEndDrag = stickyNoteDndService.onEndDrag(function () {
                    elem.removeClass(draggingClass);
                });
                var unsubscribeCompleteDrag = stickyNoteDndService.onComplete(function () {
                    elem.removeClass(blockerClass);
                });
                scope.$on("$destroy", function () {
                    unsubscribeBeginDrag();
                    unsubscribeEndDrag();
                    unsubscribeCompleteDrag();
                });
                elem.on("drop", function (e) {
                    elem.removeClass("hover");

                    var ev = e.originalEvent;

                    if (ev.dataTransfer) {
                        var source = ev.dataTransfer.getData("source");
                        if (source !== "sticky-note-add") return;
                    }
                    e.preventDefault();

                    if (zone === "Client" || zone.startsWith("Client.")) {
                        var alert = $mdDialog.alert({
                            templateUrl: "/App/Home/AddClientStickyNote/template.html",
                            controller: "addClientStickyNoteController",
                            resolve: {
                                location: [function () { return zone; }],
                                client: ["clientApi", function (clientApi) {
                                    return clientApi.get(stickyNoteZoneCtrl.clientId);
                                }]
                            },
                            clickOutsideToClose: true
                        });

                        $mdDialog.show(alert).then(function () {
                            stickyNoteDndService.completeNote();
                            stickyNoteZoneCtrl.onNewStickyNote();
                        });
                    }
                });

                elem.on("click", function (e) {
                    if (!addingStickyNote) return;

                    elem.removeClass("hover");

                    var ev = e.originalEvent;

                    if (ev.dataTransfer) {
                        var source = ev.dataTransfer.getData("source");
                        if (source !== "sticky-note-add") return;
                    }
                    e.preventDefault();

                    if (zone === "Client" || zone.startsWith("Client.")) {
                        var alert = $mdDialog.alert({
                            templateUrl: "/App/Home/AddClientStickyNote/template.html",
                            controller: "addClientStickyNoteController",
                            resolve: {
                                location: [function () { return zone; }],
                                client: ["clientApi", function (clientApi) {
                                    return clientApi.get(stickyNoteZoneCtrl.clientId);
                                }]
                            },
                            clickOutsideToClose: true
                        });

                        $mdDialog.show(alert).then(function () {
                            stickyNoteDndService.completeNote();
                        });
                    }
                });
                //this event handler has to be here for dnd events to work
                elem.on("dragover", function (e) {
                    e.preventDefault();
                    elem.addClass("hover");
                });
                elem.on("dragexit dragleave", function () { elem.removeClass("hover"); }); //if we want to do something when the mouse out of here
            }
        };
    }]);

    app.directive("stickyNoteOverlay", ["stickyNoteDndService", function (stickyNoteDndService) {
        return {
            link: function (scope, elem) {
                elem.addClass("sticky-note-overlay");

                var unsubscribeBeginDrag = stickyNoteDndService.onBeginDrag(function () {
                    elem[0].style.zIndex = 100;
                    elem[0].style.opacity = 0.6;
                });

                var unsubscribeEndDrag = stickyNoteDndService.onEndDrag(function () {
                    elem[0].style.zIndex = -1;
                    elem[0].style.opacity = 0;
                });

                scope.$on("$destroy", function () {
                    unsubscribeBeginDrag();
                    unsubscribeEndDrag();
                });
            }
        };
    }]);
})(window.app, window.angular); // jshint ignore:line